var DOMINIO = window.location.protocol + '//' + window.location.host;